import React from "react";
import startCase from "lodash/startCase";
import moment from "moment-timezone";
import { useReactToPrint } from "react-to-print";
import { Box, Button, IconButton } from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import { ConsentData, StyledTypography } from "./ConsentCreateEditForm";
import Panel from "../../../components/Panel";
import ConsentFormPrint from "./ConsentFormPrint";
import ConsentFormContent from "./ConsentFormContent";
import { clientFullNameSelector } from "../../../reducers/client";
import { convertADtoBS } from "../../../components/Calendar/functions/calendarFunctions";

interface Props {
  data: ConsentData;
  onClose: () => void;
  onEdit: () => void;
}

const ConsentFormShow = ({ data, onEdit, onClose }: Props): JSX.Element => {
  const componentRef = React.useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  return (
    <Panel
      onClose={onClose}
      title="Consent Form"
      printButton={
        <Button variant="contained" size="small" onClick={handlePrint}>
          Print
        </Button>
      }
      editButton={
        <IconButton size="small" onClick={onEdit} data-testmation="consentFormEditButton">
          <Edit />
        </IconButton>
      }
    >
      <Box>
        {data.client && (
          <div>
            <StyledTypography text={`Date: ${convertADtoBS(moment(data.created_at)).formatted2}`} />
            <StyledTypography
              text={`Patient Name: ${startCase(clientFullNameSelector(data.client))}`}
            />
          </div>
        )}
        <ConsentFormContent data={data} />
        <ConsentFormPrint ref={componentRef} data={data} />
      </Box>
    </Panel>
  );
};

export default ConsentFormShow;
